module.exports = __webpack_public_path__ + "img/clover.70263818.png";